import React, { FC, ReactElement } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  ProgressBarTileCont,
  ProgressLabelCont,
  ExpandIconCont,
} from './PRMCategoryResultsTile.styles';
import { IPRMCategoryResults } from '../../../services/reports';
import { CaptionBoldL, CaptionRegularL } from '../../../styles/globals';
import ProgressBar from '../../ProgressBar/ProgressBar';

interface IPRMCategoryResultsTile {
  category: IPRMCategoryResults;
  onClick: () => void;
  icon: ReactElement;
  isActive: boolean;
  average: number;
  group: string;
}

const PRMCategoryResultsTile: FC<IPRMCategoryResultsTile> = ({
  category,
  onClick,
  icon,
  isActive,
  average,
  group,
}) => {
  const { t } = useTranslation();

  return (
    <ProgressBarTileCont
      data-testid="progressBarTileCont"
      id="ProgressBarTileCont"
      key={category.category.code}
    >
      <ProgressLabelCont id="ProgressLabelCont">
        {isActive ? (
          <CaptionBoldL>{category.category.title}</CaptionBoldL>
        ) : (
          <CaptionRegularL>{category.category.title}</CaptionRegularL>
        )}
        <ExpandIconCont data-testid="expandIconCont" id="ExpandIconCont" onClick={onClick}>
          {icon}
        </ExpandIconCont>
      </ProgressLabelCont>
      <ProgressBar
        progress={`${category.result.score}%`}
        historicalScore={average}
        tooltip={`${t('report.prm.groupAverage')} ${group}`}
        tooltipWidth={240}
        barMode={category.result.rating}
        contWidth="100%"
        height="16px"
      />
    </ProgressBarTileCont>
  );
};

export default PRMCategoryResultsTile;
